import { render, staticRenderFns } from "./AlertUnsavedChanges.vue?vue&type=template&id=5e0b04b0"
import script from "./AlertUnsavedChanges.vue?vue&type=script&lang=js"
export * from "./AlertUnsavedChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports